import { createTheme } from '@mui/material'
import useSettingsStore from 'Store/settingsStore'
import AkaAcidBloggerOtf from '../../assets/ACBloggerRegular.otf'
import AkaAcidBloggerTtf from '../../assets/ACBloggerRegular.ttf'

const mainTheme = () => {
      const { darkMode } = useSettingsStore()
      return createTheme({
            typography: {
                  fontSize: 13,
                  fontFamily: ['AkaAcidBlogger', 'Arial', 'Helvetica', 'sans-serif'].join(','),
                  h1: {
                        fontSize: '2.5rem',
                        fontWeight: 700,
                  },
                  h2: {
                        fontSize: '2rem',
                        fontWeight: 600,
                  },
                  h3: {
                        fontSize: '1.75rem',
                        fontWeight: 600,
                  },
                  h4: {
                        fontSize: '1.5rem',
                        fontWeight: 500,
                  },
                  h5: {
                        fontSize: '1.25rem',
                        fontWeight: 500,
                  },
                  h6: {
                        fontSize: '1rem',
                        fontWeight: 500,
                  },
                  body1: {
                        fontSize: '1rem',
                  },
                  body2: {
                        fontSize: '0.875rem',
                  },
            },
            palette: {
                  mode: darkMode ? 'dark' : 'light',
                  primary: {
                        main: darkMode ? '#000' : '#fff',
                  },
                  secondary: {
                        main: darkMode ? '#fff' : '#000',
                  },
            },
            components: {
                  MuiButton: {
                        styleOverrides: {
                              root: {
                                    textTransform: 'capitalize',
                                    borderRadius: '14px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                              },
                        },
                  },
                  MuiCssBaseline: {
                        styleOverrides: `
                            @font-face {
                                font-family: 'AkaAcidBlogger';
                                src: url(${AkaAcidBloggerOtf}) format('opentype'),
                                url(${AkaAcidBloggerTtf}) format('truetype');
                                font-weight: normal;
                                font-style: normal;
                                font-display: swap;
                            }
                            body {
                                background-color: ${darkMode ? '#1f1f1f' : '#f8f8f8'};
                            }
                            `,
                  },
                  MuiFormLabel: {
                        styleOverrides: {
                              root: {
                                    color: 'black',
                              },
                        },
                  },
                  MuiInputBase: {
                        styleOverrides: {
                              root: {
                                    background: 'white',
                                    color: 'black',
                              },
                        },
                  },
                  MuiCard: {
                        styleOverrides: {
                              root: {
                                    borderRadius: 10,
                                    marginBottom: '10px',
                                    // border: '1px solid #00000014',
                                    // boxShadow: '#00000065 0px 0px 10px -3px',
                                    boxShadow: 'none',
                              },
                        },
                  },
                  MuiCardHeader: {
                        styleOverrides: {
                              root: {
                                    padding: '5px 10px',
                              },
                              // subheader: {
                              //   color: 'white'
                              // }
                        },
                  },
                  MuiCardContent: {
                        styleOverrides: {
                              root: {
                                    padding: '5px 10px',
                              },
                        },
                  },
                  MuiCardActions: {
                        styleOverrides: {
                              root: {
                                    padding: '0px 8px',
                              },
                        },
                  },
                  MuiToolbar: {
                        styleOverrides: {
                              root: {
                                    minHeight: '48px',
                              },
                        },
                  },
                  MuiBottomNavigation: {
                        styleOverrides: {
                              root: {
                                    height: '56px',
                              },
                        },
                  },
                  MuiFab: {
                        styleOverrides: {
                              root: {
                                    width: '48px',
                                    height: '48px',
                              },
                        },
                  },
                  MuiBottomNavigationAction: {
                        styleOverrides: {
                              root: {
                                    minWidth: 'auto',
                                    '& .MuiBottomNavigationAction-label': {
                                          '&.Mui-selected': {
                                                color: darkMode ? 'white' : 'black',
                                          },
                                    },
                                    '& .MuiSvgIcon-root': {
                                          color: darkMode ? 'white' : 'black',
                                          // width: 28,
                                          // height: 28,
                                    },
                              },
                        },
                  },
                  MuiImageList: {
                        styleOverrides: {
                              root: {
                                    margin: 0,
                                    // padding: '10px'
                              },
                        },
                  },
                  MuiImageListItem: {
                        styleOverrides: {
                              root: {
                                    // boxShadow: darkMode ? '#ffffff65 0px 0px 10px 1px' : '#00000065 0px 0px 10px 1px',
                                    borderRadius: '10px',
                                    justifyContent: 'center',
                                    overflow: 'hidden',
                                    '& img': {
                                          borderRadius: '10px',
                                    },
                                    '&.selected': {
                                          borderRadius: '14px',
                                          border: darkMode
                                                ? '4px solid rgb(255 255 255)'
                                                : '4px solid rgb(0, 0, 0)',
                                    },
                                    '&.isVideo': {
                                          '&:after': {
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                width: '50px',
                                                height: '50px',
                                                borderRadius: '50%',
                                                content: '"\\25B6"',
                                                color: '#ffffff99',
                                                border: '2px solid',
                                                transform: 'translate(-50%, -50%)',
                                                padding: '10px 15px',
                                                fontSize: '25px',
                                          },
                                    },
                                    '& .MuiImageListItemBar-root': {
                                          borderRadius: '10px',
                                    },
                                    '& .MuiImageListItemBar-title': {
                                          fontSize: '0.7rem',
                                    },
                              },
                        },
                  },
                  MuiImageListItemBar: {
                        styleOverrides: {
                              root: {
                                    '& .MuiImageListItemBar-titleWrap': {
                                          padding: 0,
                                    },
                              },
                        },
                  },
                  MuiTypography: {
                        styleOverrides: {
                              root: {
                                    '& p': {
                                          margin: 0,
                                    },
                              },
                        },
                  },
            },
      })
}

export default mainTheme
